import { render } from "./IconFacebook.vue?vue&type=template&id=6c7a8a0b"
import script from "./IconFacebook.vue?vue&type=script&lang=js"
export * from "./IconFacebook.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__